import styled, { keyframes } from "styled-components";
import { colors } from "@/constants";

const animation = keyframes`
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
`; 

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;

    width: 100vw;
    height: 100vh;
     
    z-index: 10000;
    position: fixed;
    top: 0;
    left: 0;
    overflow: hidden;
    max-width: var(--mobile);
    background-color: ${colors.brand.white};
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
    animation: ${animation} 0.2s ease-in-out;
`;

export const Header = styled.div`
    width: 100%;
    padding: 12px 4px;
`;

export const CloseButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 50px;
    height: 50px;

    border: none;

    svg{
        width: 22px;
        height: 22px;
        color: ${colors.gray.gray50};
    }
`;

export const FullGalleryWrapper = styled.div`
    flex-grow: 1;
    overflow: hidden;
    pointer-events: none;
`;